import React from "react";

import HSGModalComponent from "../../../HSGModalComponent/HSGModalComponent";

const MagicLinkWarning = ({ show, onClose, onForgotPassword, modalFor }) => (
    <HSGModalComponent
        show={show}
        onClose={() => onClose()}
        onHide={() => onClose()}
        header= {modalFor === 'magiclink' ? "Magic Link Failed!" : 'Login Failed'}
        isForm={false}
        body={
            modalFor === 'magiclink' ? (
            <div className="hsg-dfp-root">
                <p className="hsg-dfp-subheading"> Sorry, this link has been expired. Please request a new one.</p>

                <div>
                    <button
                        className="hsg-btn hsg-auth-content-sign-up-form-submission"
                        onClick={() => {onForgotPassword(); onClose()}}
                    >
                        Request Magic Link
                    </button>
                    <button
                        className="hsg-btn-white"
                        style={{outline: "none"}}
                        onClick={() => onClose()}
                    >
                        Login
                    </button>
                </div>
            </div>
            )
            :
            <div className="hsg-dfp-root" >
                <p className="hsg-dfp-subheading text center"> Please login using your personal login credentials.</p>
                <div style = {{display:'flex', justifyContent:'flex-end'}}>
                    <button
                        className="hsg-btn hsg-auth-content-sign-up-form-submission"
                        onClick={() => onClose()}
                    >
                        Ok
                    </button>
                </div>
            </div>
        }
    />
);

export default MagicLinkWarning;
